import React, { useState, useEffect } from 'react';
import { getTeams } from './Teams';
import { fetchData, fetchAllPicksFromWeek } from './services/api';
import {
  getFirestore,
  getDocs,
  collection,
  query,
  where
} from 'firebase/firestore';

function getCurrentDateIndex(dates) {

    const currentDate = new Date();
    const weeks = [];

    dates.forEach((dateRange, index) => {
        const [startDateStr, endDateStr] = dateRange.split(' - ');
        var year = "2026";
        if (startDateStr.includes("Jan") || startDateStr.includes("Feb")) {
            year = "2027";
        }
        const startDate = new Date(startDateStr + ", " + year);
        if (endDateStr.includes("Jan") || endDateStr.includes("Feb")) {
            year = "2027";
        }
        else {
            year = "2026";
        }
        const endDate = new Date(endDateStr + ", " + year);
        endDate.setDate(endDate.getDate() + 1); // Including end date
        weeks.push({ startDate, endDate });
    });

    var weekIndex = weeks.findIndex((week) => currentDate >= week.startDate && currentDate <= week.endDate);

    if (weekIndex === -1) {
        weekIndex = 0;
    }
    
    return weekIndex + 1;
}

const dates = [
    'Aug 1 - Sep 9',
            'Sep 10 - Sep 16',
            'Sep 17 - Sep 23',
            'Sep 24 - Sep 30',
            'Oct 1 - Oct 7',
            'Oct 8 - Oct 14',
            'Oct 15 - Oct 21',
            'Oct 22 - Oct 28',
            'Oct 29 - Nov 4',
            'Nov 5 - Nov 11',
            'Nov 12 - Nov 18',
            'Nov 19 - Nov 25',
            'Nov 26 - Dec 2',
            'Dec 3 - Dec 9',
            'Dec 10 - Dec 16',
            'Dec 17 - Dec 23',
            'Dec 24 - Dec 30',
            'Dec 31 - Jan 6',
            'Jan 7 - Jan 13',
            'Jan 14 - Jan 20',
            'Jan 21 - Jan 27',
            'May 1 - May 2',
            'Jan 28 - Feb 28',
];

const CompareWeek = ({ opponent, week, setWeek, setOpponent, onPageChange }) => {
  const db = getFirestore();
  const user = JSON.parse(localStorage.getItem('profile'));

  const [weekSelect, setWeekSelect] = useState(week ?? getCurrentDateIndex(dates));
  const [teams, setTeams] = useState([]);
  const [games, setGames] = useState([]);
  const [match, setMatch] = useState(null);
  const [myPicks, setMyPicks] = useState({});
  const [theirPicks, setTheirPicks] = useState({});
  const [points1, setPoints1] = useState(null);
  const [points2, setPoints2] = useState(null);
  const [bye, setBye] = useState(false);

  const alternates = ['Buccaneers', '49ers'];
  const white = ['Giants', 'Jets'];

  useEffect(() => {
    getTeams().then(setTeams).catch(console.error);
  }, []);


  useEffect(() => {
    const loadData = async () => {
      if (!user) return;
      if (!opponent) return;

      const allPicks = await fetchAllPicksFromWeek(weekSelect);
      const gameData = await fetchData(weekSelect, '2026');

      setGames(gameData.events);

      const my = allPicks.find(item => item.Email === user.Email);
      const theirs = allPicks.find(item => item.Email === opponent.Email);

      const myParsed = JSON.parse(my?.Picks || '{}');
      const theirParsed = JSON.parse(theirs?.Picks || '{}');

      setMyPicks(myParsed);
      setTheirPicks(theirParsed);

      let total1 = 0;
      let total2 = 0;
      
      gameData.events.forEach(game => {
        const winnerTeam = game.competitions[0].competitors.find(c => c.winner)?.team.name;

        const myPick = myParsed[game.id];
        if (myPick?.pick === winnerTeam) total1 += myPick?.val ?? 0;

        const theirPick = theirParsed[game.id];
        if (theirPick?.pick === winnerTeam) total2 += theirPick?.val ?? 0;
      });

      setPoints1(total1);
      setPoints2(total2);
    };

    loadData();
  }, [user, opponent, weekSelect]);

  const getDigit = (num, pos) => {
    if (num == null) return '';
    const str = num.toString().padStart(2, '0');
    return str[pos - 1] || '';
  };

  const getTeamColors = (team, pick) => {
    const base = team?.color;
    const alt = team?.alternateColor;
    const isAlt = alternates.includes(pick);
    return { color: isAlt ? alt : base, altColor: isAlt ? base : alt, isWhite: white.includes(pick) };
  };



  const renderPickImage = photo => (
    <img style={photo ? {} : { width: '30px', height: '30px' }} src={photo || 'ex.png'} />
  );


  const b2g = () => {
    onPageChange('weekly');
}
const changeWeek = (delta) => {
    setWeekSelect(weekSelect*1 + delta);
}

if (!user) return;
      if (!opponent) return;


  return (
    <div className="page">
<div className="backToGroups" onClick={() => b2g()}>
                <span className="reverse">&#10142;</span> &nbsp; Back to Leaderboard
            </div>
      <div className="group-matchup"> 
        <div className="group-matchup-header-buttons">
          {weekSelect > 1 && <div onClick={() => changeWeek(-1)}><span className="reverse">➞</span> Week {weekSelect - 1}</div>}
          <h2>Week {weekSelect}</h2>
          {weekSelect < 18 && <div onClick={() => changeWeek(1)}>Week {weekSelect + 1} <span>➞</span></div>}
        </div>
        <div className="group-matchup-header game">
        

          <div className="theirpicks pick">
            <div className="pick-val">
              <div className="pick-mascot">{user.Name}</div>
            </div>
            {!bye && (
              <div className="total-points">
                <span className="digitOne">{getDigit(points1, 1)}</span>
                <span className="digitTwo">{getDigit(points1, 2)}</span>
              </div>
            )}
          </div>
          <div className="x">VS</div>
          <div className="mypicks pick">
            {!bye && (
              <div className="total-points">
                <span className="digitOne">{getDigit(points2, 1)}</span>
                <span className="digitTwo">{getDigit(points2, 2)}</span>
              </div>
            )}
            <div className="pick-val">
              <div className="pick-mascot">{opponent.Name}</div>
            </div>
          </div>
        </div>

        {!bye && (
          <div>
            {games.length > 0 &&
              games.map((item, index) => {
                const comp = item.competitions[0].competitors;
                const winner = comp.find(c => c.winner)?.team || null;
                const date = new Date(item.date);

                const hasStarted = new Date() > date || item.competitions[0].status?.type?.description !== 'Scheduled';

                const hour12 = date.toLocaleTimeString([], { hour: 'numeric', hour12: true });
                const dayName = date.toLocaleDateString([], { weekday: 'long' });
                const currentDay = date.toDateString();
                const showDayHeader = index === 0 || new Date(games[index - 1].date).toDateString() !== currentDay;

                const p1 = myPicks[item.id];
                const p2 = theirPicks[item.id];

                const t1 = comp.find(c => c.team.name === p1?.pick)?.team;
                const { color: c1, isWhite: white1 } = getTeamColors(t1, p1?.pick);
                const correct1 = winner ? winner.name === t1?.name : null;

                const t2 = comp.find(c => c.team.name === p2?.pick)?.team;
                const { color: c2, isWhite: white2 } = getTeamColors(t2, p2?.pick);
                const correct2 = winner ? winner.name === t2?.name : null;

                const middle = (
                  <>
                    {correct1 === true ? (
                      <div className="correctGuess">
                        <img width="15" src="check.png" alt="Correct" />
                      </div>
                    ) : correct1 === false ? (
                      <div className="wrongGuess">
                        <img width="15" src="ex.png" alt="Wrong" />
                      </div>
                    ) : (
                      hour12
                    )}

                    {correct2 === true ? (
                      <div className="correctGuess">
                        <img width="15" src="check.png" alt="Correct" />
                      </div>
                    ) : correct2 === false ? (
                      <div className="wrongGuess">
                        <img width="15" src="ex.png" alt="Wrong" />
                      </div>
                    ) : (
                      null
                    )}
                  </>
                );


                return (
                  <React.Fragment key={item.id}>
                    {showDayHeader && <div className="day-header">{dayName}</div>}
                    <div className={`game ${p1?.pick === p2?.pick || !hasStarted ? 'dull' : 'Highlighted'}`}>
                      <div className={`mypicks pick ${correct1 === true ? 'correct' : correct1 === false ? 'incorrect' : ''}`}>
                        <div className="pick-val">
                          <div className="pick-num" style={{ background: !hasStarted ? '#aaa' : `#${c1 || 'ccc'}` }}>
                            {!hasStarted ? '?' : p1?.val ?? 0}
                          </div>
                          <div className="pick-dash" style={{ background: !hasStarted ? '#aaa' : `#${c1 || 'ccc'}` }} />
                        </div>
                        <div className={`pick-image${white1 ? ' white-filter' : ''}`} style={{ background: !hasStarted ? '#aaa' : `#${c1 || 'ccc'}` }}>
                          {!hasStarted ? '?' : renderPickImage(teams[p1?.pick]?.photo)}
                        </div>
                      </div>
                      <div className="x">{middle === '12 AM' ? 'TBD' : middle}</div>
                      <div className={`theirpicks pick ${correct2 === true ? 'correct' : correct2 === false ? 'incorrect' : ''}`}>
                        <div className={`pick-image${white2 ? ' white-filter' : ''}`} style={{ background: !hasStarted ? '#aaa' : `#${c2 || 'ccc'}` }}>
                          {!hasStarted ? '?' : renderPickImage(teams[p2?.pick]?.photo)}
                        </div>
                        <div className="pick-val">
                          <div className="pick-dash" style={{ background: !hasStarted ? '#aaa' : `#${c2 || 'ccc'}` }} />
                          <div className="pick-num" style={{ background: !hasStarted ? '#aaa' : `#${c2 || 'ccc'}` }}>
                            {!hasStarted ? '?' : p2?.val ?? 0}
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompareWeek;

// Matchup fetcher
const findPlayerMatchup = async (groupId, week, playerEmailOrId) => {
    console.log(groupId);
  const db = getFirestore();
  const matchupsRef = collection(db, 'Groups', groupId, 'Matchups');

  const weekNumber = typeof week === 'string' ? parseInt(week, 10) : week;

  const homeQuery = query(matchupsRef, where('week', '==', weekNumber), where('home', '==', playerEmailOrId));
  const awayQuery = query(matchupsRef, where('week', '==', weekNumber), where('away', '==', playerEmailOrId));

  const [homeSnap, awaySnap] = await Promise.all([getDocs(homeQuery), getDocs(awayQuery)]);

  if (homeSnap.docs.length > 0) return homeSnap.docs[0].data();

  if (awaySnap.docs.length > 0) {
    const data = awaySnap.docs[0].data();
    return {
      ...data,
      home: data.away,
      away: data.home,
      homeScore: data.awayScore,
      awayScore: data.homeScore
    };
  }

  console.warn(`No matchup found for ${playerEmailOrId} in week ${weekNumber} of group ${groupId}`);
  return null;
};
